import { render } from "./StandingsThurB.vue?vue&type=template&id=050c64d8&scoped=true"
import script from "./StandingsThurB.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsThurB.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsThurB.vue?vue&type=style&index=0&id=050c64d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050c64d8"]])

export default __exports__